/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AccordionModule } from 'primeng/accordion';
import { MenuModule } from 'primeng/menu';

import { AuthenticationUserDropdownCommunityModule } from '@usheru-hff/authentication/user-dropdown-community';
import { LanguageSelectorComponent } from '@usheru-hff/core/language-selector';
import { HffCommonUiUserDropdown } from '@usheru-hff/hff-common/ui-user-dropdown';
import { SearchMovieComponent } from '@usheru-hff/shared/feature-search-movie';
import { SharedFeatureSocialLinksModule } from '@usheru-hff/shared/feature-social-links';
import { IntersectionObserverDirective } from '@usheru-hff/shared/intersection-observable';
import { SharedUtilsModule } from '@usheru-hff/shared/utils';
import { SharedUtilsImageModule } from '@usheru-hff/shared/utils-image';
import { ChannelLinkLocalizePipe } from '@usheru-hff/ui/channel-localize';

import { HeaderComponent } from './header/header.component';
import { HeaderDebugDirective } from './header/header.debug.directive';
import { NormalizeRoutePipe } from './header/normalize-route.pipe';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild([]),
    SearchMovieComponent,
    SharedUtilsImageModule,
    SharedFeatureSocialLinksModule,
    FontAwesomeModule,
    HffCommonUiUserDropdown,
    MenuModule,
    SharedUtilsModule,
    LanguageSelectorComponent,
    AuthenticationUserDropdownCommunityModule,
    NormalizeRoutePipe,
    ChannelLinkLocalizePipe,
    IntersectionObserverDirective,
    HeaderDebugDirective,
    AccordionModule
  ],
  declarations: [HeaderComponent],
  exports: [HeaderComponent]
})
export class HffCommonUiHeaderModule {}
